<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.batchImport')"
    width="400px"
    :close-on-click-modal="false"
    append-to-body
  >
    <div class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form label-width="110px" label-position="left">
        <el-form-item :label="$t('Partners.firstPlease')">
          <el-button type="primary" @click="downLoadTemplate">{{ $t('SeaExport.TemplateDownload') }}</el-button>
        </el-form-item>
        <el-form-item :label="$t('Partners.selectImportFile')">
          <el-upload
            v-if="innerVisible"
            ref="upload"
            :limit="1"
            class="upload-demo"
            :action="action"
            :auto-upload="false"
            accept=".xls,.xlsx"
            :on-success="uploadSuccess"
            :on-error="uploadExcelError"
          >
            <el-button slot="trigger" size="small" type="primary">{{ $t('SeaExport.UploadFile') }}</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="">
          <label>{{ $t('Partners.fileSizeCannotExceed20m') }}</label>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer">
      <el-button type="primary" @click="submitUpload">{{ $t('Partners.startImport') }}</el-button>
      <el-button @click="closeHandler">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import URL from '@/api/urlTranslator'
import { cache, cacheName } from '@/utils/cacheManager'
import { getLoading4Cxt } from '@/utils/utilBaseElement'

export default {
  name: 'ImportCabinetListWindow',
  props: {
    visible: { type: Boolean, required: true },
    jobUuid: { type: String, required: true }
  },
  data() {
    return {
      loading: false,
      URL,
      innerVisible: false,
      uploadSetting: ''
    }
  },
  computed: {
    sessionId() {
      return this.$store.getters.token
    },
    action() {
      return URL.seaExport.saveCabinetListExcelFile + '?sessionId=' + this.$store.getters.token + '&jobUuid=' + this.jobUuid + '&branchId=' + this.$store.getters.currentOfficeId + '&isAdmin=' + this.$store.getters.isAdmin
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    await cache.load(cacheName.USER, cacheName.CONFIG)
  },
  methods: {
    // 下载模板
    downLoadTemplate() {
      ExportUtils.downloadTemplateFile('ImportCabinetListTemplate.xls', 'partner')
    },
    // 开始导入-确定导入
    submitUpload() {
      const files = this.$refs.upload.uploadFiles
      if (!files || files.length <= 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectFile'))
        return
      }
      this.loading = getLoading4Cxt(this)
      this.$refs.upload.submit()
    },
    // 导入成功
    uploadSuccess(response, file, fileList) {
      this.loading.close()
      if (response && response.data) {
        const data = response.data
        if (data.success) {
          this.$message.success(this.$t('Message.ImportSuccessful1'))
          this.$emit('uploadExcelSuccess')
          this.closeHandler()
        } else {
          this.$confirm(data.errMsg, this.$t('FileHistory.Tips'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            const documentId = data.sessionId
            this.downloadResultLog(documentId)
            this.closeHandler()
          }).catch(() => {
            this.$refs.upload.clearFiles()
            if (this.loading) this.loading.close()
          })
        }
      } else {
        this.uploadExcelError()
      }
    },
    uploadExcelError() {
      this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
      this.closeHandler()
    },
    closeHandler() {
      this.$refs.upload.clearFiles()
      if (this.loading) this.loading.close()
      this.innerVisible = false
    },
    // 下载导入结果
    downloadResultLog(documentId) {
      // 从云存储上下载文件
      if (!documentId) {
        this.$message.warning(this.$t('SeaExport.NoCorrespondingFile'))
        return
      }
      const storageURL = cache.config.get('StorageURL')
      const url = `${URL.common.findByFileId}/${documentId}?sessionId=${this.sessionId}`
      window.open(url)
    }
  }
}
</script>

<style scoped>

</style>
